import { FC } from 'react';

const IconHotel: FC = (props) => {
	return (
		<div {...props}>
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g opacity="0.7">
					<path
						d="M2 19V12.625C2 12.2083 2.08333 11.8167 2.25 11.45C2.41667 11.0833 2.66667 10.7833 3 10.55V7.65C3 6.9 3.25417 6.27083 3.7625 5.7625C4.27083 5.25417 4.9 5 5.65 5H10.15C10.5167 5 10.8583 5.08333 11.175 5.25C11.4917 5.41667 11.7667 5.64167 12 5.925C12.2333 5.64167 12.5042 5.41667 12.8125 5.25C13.1208 5.08333 13.4583 5 13.825 5H18.325C19.075 5 19.7083 5.25417 20.225 5.7625C20.7417 6.27083 21 6.9 21 7.65V10.55C21.3333 10.7833 21.5833 11.0833 21.75 11.45C21.9167 11.8167 22 12.2083 22 12.625V19H20.5V17H3.5V19H2ZM12.75 10.125H19.5V7.65C19.5 7.31667 19.3875 7.04167 19.1625 6.825C18.9375 6.60833 18.6583 6.5 18.325 6.5H13.75C13.4667 6.5 13.2292 6.61667 13.0375 6.85C12.8458 7.08333 12.75 7.35 12.75 7.65V10.125ZM4.5 10.125H11.25V7.65C11.25 7.35 11.1542 7.08333 10.9625 6.85C10.7708 6.61667 10.5333 6.5 10.25 6.5H5.65C5.33333 6.5 5.0625 6.6125 4.8375 6.8375C4.6125 7.0625 4.5 7.33333 4.5 7.65V10.125ZM3.5 15.5H20.5V12.625C20.5 12.3417 20.4042 12.1042 20.2125 11.9125C20.0208 11.7208 19.7833 11.625 19.5 11.625H4.5C4.21667 11.625 3.97917 11.7208 3.7875 11.9125C3.59583 12.1042 3.5 12.3417 3.5 12.625V15.5Z"
						fill="white"
					/>
				</g>
			</svg>
		</div>
	);
};
export default IconHotel;
